import type { BriefAgentRun } from '../../data/types';

interface AgentActivityLogProps {
  runs: BriefAgentRun[];
  wide?: boolean;
}

export function AgentActivityLog({ runs, wide = false }: AgentActivityLogProps) {
  return (
    <section className={`${wide ? 'lg:col-span-12' : 'lg:col-span-5'} bg-bg-secondary border border-border-default rounded-xl overflow-hidden flex flex-col`}>
      <header className="flex items-center justify-between px-4 py-3 border-b border-border-light">
        <h3 className="font-sans font-medium text-[12.5px] text-text-primary m-0">Agent activity overnight</h3>
        <span className="font-mono text-[10.5px] text-text-secondary px-1.5 py-px bg-bg-tertiary rounded border border-border-default">
          since last sign-out
        </span>
      </header>
      <div className="font-mono text-[11px] py-1.5">
        {runs.length === 0 ? (
          <div className="px-4 py-12 text-center text-text-secondary text-sm">No agent activity recorded.</div>
        ) : (
          runs.map((r, i) => (
            <div
              key={i}
              className="grid grid-cols-[44px_70px_1fr] gap-2.5 px-4 py-1.5 leading-[1.5]"
            >
              <span className="text-text-secondary">{r.time}</span>
              <span className="text-brand-blue font-medium">{r.agent}</span>
              <span className="text-text-secondary">{r.action}</span>
            </div>
          ))
        )}
      </div>
    </section>
  );
}
